module.exports = __webpack_public_path__ + "img/1.1387c486.jpg";